import moment from 'moment';
import Text from '../../../components/detail/components/Text.component';
import dayjs from 'dayjs';
import LinkPermission from '../../../components/detail/components/LinkPermission.component';
import { Chip, Stack } from '@mui/material';

export const DetailConf = {
  initialState: {
    loading: false,
    error: null,
    data: null,
    meta: null,
  },
  fields: [
    {
      id: 'user_type_section',
      type: 'section',
      label: 'User Type',
      xs: 12,
      items: [
        {
          type: 'text',
          label: 'User Type',
          key: 'userType.label',
          xs: 12,
          sm: 6,
        },
      ],
    },
    {
      id: 'contact_section',
      type: 'section',
      label: 'Contact',
      xs: 12,
      items: [
        {
          type: 'text',
          label: 'Username',
          key: 'id_users_permissions_user.username',
          xs: 12,
          sm: 6,
        },
        {
          type: 'text',
          label: 'Email',
          key: 'id_users_permissions_user.email',
          xs: 12,
          sm: 6,
        },
        {
          type: 'text',
          label: 'First Name',
          key: 'id_users_permissions_user.name',
          xs: 12,
          sm: 6,
        },
        {
          type: 'text',
          label: 'Last Name',
          key: 'id_users_permissions_user.surname',
          xs: 12,
          sm: 6,
        },
        {
          type: 'text',
          label: 'Birthdate',
          key: 'id_users_permissions_user.birthdate',
          xs: 12,
          sm: 6,
        },
        {
          type: 'text',
          label: 'Phone',
          key: 'id_users_permissions_user.phone_number',
          xs: 12,
          sm: 6,
        },
      ],
    },
    {
      id: 'yacht_section',
      type: 'section',
      label: 'Yacht',
      xs: 12,
      items: [
        {
          type: 'text',
          label: 'Name',
          key: 'id_yacht',
          xs: 12,
          sm: 6,
        },
        {
          type: 'text',
          label: 'Role',
          key: 'crew_responsability',
          xs: 12,
          sm: 6,
        },
        {
          type: 'text',
          label: 'Start Date',
          key: 'start_date',
          xs: 12,
          sm: 6,
        },
        {
          type: 'text',
          label: 'End Date',
          key: 'end_date',
          xs: 12,
          sm: 6,
        },
        {
          type: 'text',
          label: 'Last Update',
          key: 'updatedAt',
          xs: 12,
          sm: 6,
        },
        {
          type: 'text',
          label: 'Manager on board',
          key: 'is_delivery_manager_on_board',
          xs: 12,
          sm: 6,
        },

      ],
    },
  ],
  formatValue: (key, value) => {
    switch (key) {
      case 'id_yacht':
        return (
          <Stack direction='row' spacing={1}>
            <Text
              label='Yacht name'
              value={
                <LinkPermission
                  to={`/yachts/${value?.id}`}
                  value={value?.yacht_name}
                  page='YACHTS'
                />
              }
            />
            <Chip label={`#${value?.id || '-'}`} size='small' />
          </Stack>
        );

      case 'id_users_permissions_user.birthdate':
        return (
          <Text
            label='Birthdate'
            value={value ? moment(value).format('DD-MM-YYYY') : '-'}
          />
        );

      case 'start_date':
        return (
          <Text
            label='Start Date'
            value={value ? moment(value).format('DD-MM-YYYY') : '-'}
          />
        );

      case 'end_date':
        return (
          <Text
            label='End Date'
            value={value ? moment(value).format('DD-MM-YYYY') : '-'}
          />
        );

      case 'updatedAt':
        return (
          <Text
            label='Last Update'
            value={`${dayjs(value).format('DD-MM-YYYY')} - ${dayjs().format('HH:mm')}`}
          />
        );

      default:
        return null;
    }
  },
};